module.exports = __webpack_public_path__ + "static/media/Deterra-Mage.de25f73c.png";